<script>
import ApiWst from "./ApiWst";
import Permisos from "./Permisos";
const yo = ApiWst.fetchLocal("yo") || {};
HelperFunctions.sujeto = yo;
import HelperFunctions from "./HelperFunctions";
const exportable = {
  ...ApiWst,
  ...Permisos,
  ...HelperFunctions,
};
export default exportable;
</script>
